import restfulBase from '@/services/negotiations/core/base';

const apiService = restfulBase('benefits');

export default apiService;
